import NavigationBar from 'layouts/navigation-bar/navigation-bar';
import { HeaderWrapper } from './header.style';

import { Container } from 'assets/styles/pages.style';

const Header = () => {
  return (
    <HeaderWrapper>
      <Container>
        <NavigationBar />
      </Container>
    </HeaderWrapper>
  );
};

export default Header;
